import type { FieldValues, FieldPath } from "react-hook-form";
import { ErrorMessage, InputField } from "@clarityos/ui";
import type { InputFieldInputProps, InputFieldTextareaProps } from "@clarityos/ui";
import { FormField } from "./FormField";

type OmittedKeys = "name" | "value" | "onChange" | "onBlur" | "ref";

type FormInputFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = (
  | Omit<InputFieldInputProps, OmittedKeys>
  | Omit<InputFieldTextareaProps, OmittedKeys>
) & {
  name: TName;
};

export function FormInputField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, ...inputProps }: FormInputFieldProps<TFieldValues, TName>) {
  return (
    <FormField
      name={name}
      render={({ errorMessage, disabled, ...fieldProps }) => (
        <InputField
          {...inputProps}
          {...fieldProps}
          disabled={inputProps.disabled || disabled}
          state={errorMessage ? "error" : "default"}
          helper={
            errorMessage ? <ErrorMessage message={errorMessage} /> : undefined
          }
        />
      )}
    />
  );
}
